import * as React from "react";
import styled from "styled-components";

const NavbarDropdownLabelWrapper = ({
  children,
  className,
  open,
  ...otherProps
}) => {
  const childrenWithOpenProp = React.Children.map(children, (child) =>
    React.cloneElement(child as any, { open })
  );

  return (
    <div className={className} {...otherProps}>
      {childrenWithOpenProp}
    </div>
  );
};

export default styled(NavbarDropdownLabelWrapper)`
  padding: 27px 32px 28px;
  cursor: pointer;
  span:focus {
    outline: none;
  }
  span:active {
    outline: none !important;
  }
`;
